export function getExt(url) {
    return url.trim().toLowerCase().split('.').pop();
}

export function download(url, name) {
    const elink = document.createElement('a');
    elink.style.display = 'none';
    elink.href = url;
    elink.download = name;
    document.body.appendChild(elink);
    elink.click();
    document.body.removeChild(elink);
}

export function getKeyCode(event) {
        return Number(event.keyCode);
    }

export function isPlaying($video) {
    return !!($video?.currentTime > 0 && !$video?.paused && !$video?.ended && $video?.readyState > 2);
}
